import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  meetingRegisterData: [],
  archiveMeetingRegisterData: [],
  uniqueMeetingType: [],
  uniqueAccountManager: [],
  uniqueCreatedAt: [],
  publicHolidaysData: [],
  meetingLocationData: [],
  meetingDueData: [],
  meetingRegisterSettingData: [],
};

const MeetingRegisterSlice = createSlice({
  name: "MeetingRegisterSlice",
  initialState,
  reducers: {
    setMeetingRegisterData: (state, action) => {
      state.meetingRegisterData = action.payload;
    },
    setArchiveMeetingRegisterData: (state, action) => {
      state.archiveMeetingRegisterData = action.payload;
    },
    setUniqueMeetingType: (state, action) => {
      state.uniqueMeetingType = action.payload;
    },
    setUniqueAccountmanager: (state, action) => {
      state.uniqueAccountManager = action.payload;
    },
    setUniqueCreatedAt: (state, action) => {
      state.uniqueCreatedAt = action.payload;
    },
    setPublicHolidaysData: (state, action) => {
      state.publicHolidaysData = action.payload;
    },
    setMeetingLocationData: (state, action) => {
      state.meetingLocationData = action.payload;
    },
    setMeetingDueData: (state, action) => {
      state.meetingDueData = action.payload;
    },
    setMeetingRegisterSettingData: (state, action) => {
      state.meetingRegisterSettingData = action.payload;
    },
  },
});
export const {
  setMeetingRegisterData,
  setArchiveMeetingRegisterData,
  setUniqueMeetingType,
  setUniqueAccountmanager,
  setUniqueCreatedAt,
  setPublicHolidaysData,
  setMeetingLocationData,
  setMeetingDueData,
  setMeetingRegisterSettingData,
} = MeetingRegisterSlice.actions;

export default MeetingRegisterSlice.reducer;
